(function ($) {
    $(document).ready(function () {
        if ($('.featured-grid').length > 0) {
            // var emptyText = $('.featured-grid .card-wrapper a'), emptyText1 = $('.featured-grid .small-card-wrapper a'),
            btnWidth = $(".featured-grid .intro .btn-wrapper").outerWidth() + "px";

            $(".featured-grid .intro .text-wrap").css({width: "calc(100% - " + btnWidth + ")"});
            // emptyText.html("Read More");
            // emptyText1.html("Read More");

            if ($(window).width() < 596) {
                btnWidth = $(".featured-grid .intro .btn-wrapper").outerWidth() + 7 + "px";
                $(".featured-grid .intro .text-wrap").css({width: "calc(100% - " + btnWidth + ")"});
            }
            $('.featured-grid').each(function () {
                if ($(this).hasClass('large-feature-grid')) {
                    $(".featured-grid.large-feature-grid .column-wrapper .eight-col .card-wrapper .card-content h3").addClass('heading-h2');
                    $(".featured-grid.large-feature-grid .column-wrapper .eight-col .card-wrapper .card-content .heading-h2").dotdotdot({
                        height: 170,
                        fallbackToLetter: true,
                        watch: true,
                    });
                }
                else {
                    $(".featured-grid .column-wrapper .eight-col .card-wrapper .card-content h3").dotdotdot({
                        height: 80,
                        fallbackToLetter: true,
                        watch: true,
                        
                    });
                    // $(".featured-grid .column-wrapper .eight-col .card-wrapper .card-content.ellipsis h3").removeAttr('style');


                    // $(".featured-grid .column-wrapper .eight-col .card-wrapper .card-content > p").dotdotdot({
                    //     height: 72,
                    //     fallbackToLetter: true,
                    //     watch: true,
                    // });

                    $(".featured-grid .column-wrapper .four-col .small-card-wrapper .small-card-content h6").dotdotdot({
                        height: 68,
                        fallbackToLetter: true,
                        watch: true,
                    });

                    $(".featured-grid .column-wrapper .four-col .small-card-wrapper .small-card-content .small-card-info span").dotdotdot({
                        height: 81,
                        fallbackToLetter: true,
                        watch: true,
                    });
                }
            });

            // $('.featured-grid').each(function () {
            //     $('.card-wrapper').each(function () {
            //         if ($(this).find('.author-info.with-image .image').length > 0) {
            //             $(this).find(".author-info.with-image p").css("margin-left", "64px");
            //         }
            //         else {
            //             $(this).find(".author-info.with-image p").css("margin-left", "0");
            //         }
            //     });
            // });
        }

        setTimeout(function () {
            $('.featured-grid.library .column-wrapper .four-col .small-card-wrapper .small-card-content p').each(function () {
                $(this).find('a').clone().appendTo($(this).parent().parent().find(".small-card-img"));
            });
        }, 400);


        $('body .featured-grid .column-wrapper .eight-col .card-wrapper .card-content span.name-tag.research a').append('<span class="comma">,</span>');

        $('.foryou-form .column-wrapper .col-four .ais-Hits-list .ais-Hits-item .small-card-wrapper.hide').closest('.ais-Hits-item').hide();

    });


})(jQuery);
